import React, { Suspense, useEffect, useRef, useState } from 'react';
import Loader from '../../../../components/loader';
import { Controller, set, SubmitHandler, useForm } from 'react-hook-form';
import Button from '../../../../components/elements/button';
import moment from 'moment';
import SelectBox from '../../../../components/elements/form/selectBox';
import { useFacilityManagersSelector } from '../../../../store/selectors/masterSelector';
import { useNavigate } from 'react-router-dom';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';
import toast from 'react-hot-toast';
import { useUserSelector } from '../../../../store/selectors/userSelector';
import { useWorkOrderApi } from '../../../../store/api/hooks/workOrderApiHook';
import { useCycleCountApi } from '../../../../store/api/hooks/cycleCountApiHook';
import { Loading } from 'react-daisyui';

interface Props {
    _ref?: any;
    editData?: any;
    WOID: any;
    onCreate?: () => void;
    onCancel?: () => void;
};

interface PartsAvailableCountProps {
    PartID: any;
    facilityID: any;
    index: number;
    onCaptureData: (data: any) => void;
}

type FormValues = {
    pickedByID: any;
    facilityID: any;
};


const PartsAvailableCountLazy: React.FC<PartsAvailableCountProps> = ({ PartID, facilityID, index, onCaptureData = (data: any) => { } }) => {
    const cycleApi: any = useCycleCountApi();
    const [availableCount, setAvailableCount] = useState<number | null>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const loadAvailableCountApi = async () => {
        setLoading(true);
        const availablestockqtyresp: any = await new Promise((resolve, reject) => {
            cycleApi.GetStockCount({ partID: PartID, facilityID: facilityID }, (presp: any) => {
                resolve(presp);
            }, (error: any) => {
                reject(null);
            });
        }).catch((error: any) => {
            return null;
        });
        if (availablestockqtyresp && availablestockqtyresp.hasOwnProperty(`currentStock`) && +availablestockqtyresp.currentStock >= 0) {
            setAvailableCount(+availablestockqtyresp.currentStock);
            onCaptureData({
                qty: +availablestockqtyresp.currentStock,
                index: index
            });
        }
        setLoading(false);
    };

    useEffect(() => {
        if (PartID && facilityID) {
            loadAvailableCountApi();
        } else {
            setAvailableCount(0);
            onCaptureData({
                qty: 0,
                index: index
            });
        }
    }, [PartID, facilityID]);
    if (loading) return <Loading className={`text-primary w-4 h-4`} />;
    return (
        <span>{availableCount}</span>
    );
};

const CreateStockpickingSingleWO: React.FC<Props> = ({ _ref, editData, WOID, onCreate = () => { }, onCancel = () => { } }) => {
    const { control, register, handleSubmit, formState: { errors }, watch, setValue, getValues } = useForm<FormValues>();
    const navigate = useNavigate();

    const divRef = useRef<any>(null);
    const spDate = moment().format(`YYYY-MM-DD HH:mm:ss`);
    const pickNo = Date.now();

    const facilityApi: any = useFacilitiesApi();
    const workOrderApi = useWorkOrderApi();

    const logedinuser: any = useUserSelector();
    const users = useFacilityManagersSelector();

    const [showLoader, setShowLoader] = React.useState<boolean>(false);
    const [showPartsLoader, setShowPartsLoader] = React.useState<boolean>(false);
    const [facilityoption, setFacilityoption] = useState<any>([]);

    //{ partID: 0, partCode: `P000000000001`, PartName: `Steel wire Net`, requiredQty: 5, availableQty: 10, pickQty: 0, unitID: 0, unitCode: `Kg`, unitPrice: 0 },    
    const [partsItems, setPartsItems] = useState<any[]>([]);

    const facilityIDWatcher = watch(`facilityID`);

    const onOutsideClick = () => {
        handleOnClickCellEdit()
    }

    const handleOnClickCellEdit = (identifier: string = ``, e: any = null) => {
        if (identifier) {
            const cellElement = document.querySelector(`#${identifier}`) as HTMLDivElement;
            const previewElement = cellElement.querySelector(`.preview-value`) as HTMLDivElement;
            const editElement = cellElement.querySelector(`.edit-value`) as HTMLDivElement;
            if (previewElement && editElement) {
                if (cellElement.id === `${identifier}`) {
                    if (!previewElement.classList.contains(`hidden`)) previewElement.classList.add(`hidden`);
                    if (editElement.classList.contains(`hidden`)) editElement.classList.remove(`hidden`);
                }
            }
        }

        //resetOthersCellEditState(`part-item-name-${index}`);
        const editableList = document.querySelectorAll(`.editable`) as NodeListOf<HTMLDivElement>
        //console.log("editableList", editableList);
        for (let i = 0; i < editableList.length; i++) {
            const editableCell = editableList[i];
            const preview = editableCell.querySelector(`.preview-value`) as HTMLDivElement;
            const edit = editableCell.querySelector(`.edit-value`) as HTMLDivElement;
            if (editableCell.id !== `${identifier}`) {
                if (preview.classList.contains(`hidden`)) preview.classList.remove(`hidden`);
                if (!edit.classList.contains(`hidden`)) edit.classList.add(`hidden`);
            }
        }

    };

    const onLoadNextStep = async () => {
        if (WOID) {
            const WOIDs = WOID;
            setShowPartsLoader(true);
            const partsresp = await new Promise((resolve, reject) => {
                workOrderApi.GetPartsByWOID({ WorkOrderIDs: WOIDs }, (resp: any) => {
                    if (resp && resp.hasOwnProperty(`code`) && resp.code === 200 && resp.hasOwnProperty(`successful`) && resp.successful === true && resp.hasOwnProperty(`woPartsDetailsList`) && Array.isArray(resp.woPartsDetailsList)) {
                        resolve(resp.woPartsDetailsList);
                    } else {
                        resolve([]);
                    }
                }, (error: any) => {
                    toast.error(error);
                    reject([]);
                });
            }).catch((err) => {
                toast.error(err);
            });
            console.log("Parts response =>", partsresp);
            setShowPartsLoader(false);
            if (partsresp && Array.isArray(partsresp) && partsresp.length > 0) {
                const facilityIDinput = getValues(`facilityID`);
                if (facilityIDinput && typeof facilityIDinput === 'object' && facilityIDinput.value) {
                    //loadPartsAvailableQty
                }
                setPartsItems(partsresp.map((item: any) => ({
                    partID: item.partsID || null,
                    partCode: item.partsCode || null,
                    PartName: item.partsName || `--`,
                    requiredQty: item.requiredQty || 0,
                    availableQty: 0,
                    pickQty: 0, // Initialize pickQty to 0
                    unitID: item.unitID || null,
                    unitCode: item.unitCode || `--`,
                    unitPrice: item.pricePerUnit || 0,
                    avgUnitCost: item.avgUnitCost || 0
                })));
            } else {
                setPartsItems([]);
            }
        } else {
            toast.error(`Please select at least one Task to proceed.`);
            return;
        }
    };

    const onSubmit: SubmitHandler<FormValues> = async (data: any) => {
        console.log("Form Data =>", data);
        console.log("Parts Items =>", partsItems);

        const payload: any = {
            request: [
                {
                    pickNo: pickNo,
                    pickingDate: moment(spDate, `YYYY-MM-DD HH:mm:ss`).utc().toISOString(),
                    refWorkorderID: WOID,
                    pickedByID: null,
                    facilityID: null,
                    pickNote: ``,
                    subFacilityID: null,
                    stockPickDetails: []
                }
            ]
        };

        if (partsItems.length === 0) {
            toast.error(`Please add parts to proceed.`);
            return;
        }

        if (partsItems.length > 0) {
            /*
            const blnkitem = partsItems.filter(item => +item.pickQty < 1);
            if (blnkitem.length > 0) {
                toast.error(`Please enter valid picked quantity for all parts.`);
                return;
            }
            */
            const invalidItems = partsItems.filter(item => item.pickQty > item.availableQty);
            if (invalidItems.length > 0) {
                toast.error(`Picked quantity cannot exceed available quantity for some parts.`);
                return;
            }
            const pickstock = partsItems.filter(item => +item.pickQty > 0);
            if (pickstock.length < 1) {
                toast.error(`In order to save atleast one part must be picked.`);
                return;
            }

            //{ partID: 0, partCode: `P000000000001`, PartName: `Steel wire Net`, requiredQty: 5, availableQty: 10, pickQty: 0, unitID: 0, unitCode: `Kg` },
            payload.request[0].stockPickDetails = pickstock.map(item => ({
                partsID: item.partID,
                pickQuantity: item.pickQty,
                partsCostRate: item.avgUnitCost || 0,
                partsTotalAmount: (item.avgUnitCost * item.pickQty) || 0,
                unitID: item.unitID
            }));
        }
        if (logedinuser && logedinuser.hasOwnProperty(`userID`) && logedinuser.userID) {
            payload.request[0].pickedByID = logedinuser.userID;
        } else {
            toast.error(`Loggedin user not founnd, who is picking the stock.`);
            return;
        }

        payload.request[0].facilityID = data.facilityID && typeof data.facilityID === 'object' && data.facilityID.hasOwnProperty('value') ? data.facilityID.value : null;
        payload.request[0].pickNote = `Picked by ${data.pickedByID && typeof data.pickedByID === 'object' ? data.pickedByID.label : ''} on ${moment().format('MM/DD/YYYY hh:mm A')}`;
        
        console.log("Final payload is here -> ", payload);

        setShowLoader(true);
        const pickstockresp: any = await new Promise((resolve, reject) => {
            workOrderApi.InsertStockPicking(payload, (resp: any) => {
                resolve(resp);
            }, (error: any) => {
                reject(error);
            });
        }).catch((err) => {
            return null;
        });
        setShowLoader(false);
        console.log("Pick stock response =>", pickstockresp);
        if (pickstockresp && pickstockresp.hasOwnProperty(`code`) && pickstockresp.code === 200 && pickstockresp.hasOwnProperty(`successful`) && pickstockresp.successful === true) {
            toast.success(pickstockresp.message);
            onCreate();
        } else {
            toast.error(pickstockresp && pickstockresp.hasOwnProperty(`message`) ? pickstockresp.message : `Error while create picking stock.`);
        }
    };

    const init_page_data = async () => {
        setShowLoader(true);
        //Facility list api get
        const facilityresp = await new Promise((resolve, reject) => {
            facilityApi.getFacilityList({}, (resp: any) => {
                if (resp.hasOwnProperty(`code`) && resp.code === 200 && resp.hasOwnProperty(`successful`) && resp.successful === true && resp.hasOwnProperty(`facilityList`) && Array.isArray(resp.facilityList)) {
                    resp.facilityList = resp.facilityList.map((item: any) => {
                        return {
                            label: item.facilityName,
                            value: item.facilityID,
                            data: item
                        };
                    });
                    resolve(resp.facilityList);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                toast.error(`Error while loading facilities: ${error.message || error}`);
                reject(error);
            });
        }).catch((err) => {
            return [];
        });
        setFacilityoption(facilityresp);
        if (logedinuser && logedinuser.hasOwnProperty(`userID`) && logedinuser.userID) {
            setValue(`pickedByID`, { label: (logedinuser.lastName + ` ` + logedinuser.firstName), value: logedinuser.userID });
        }
        onLoadNextStep();
        setShowLoader(false);

        //Load Tasks
        //await loadWorkOrders(logedinuser.userID);        
    };

    useEffect(() => {
        init_page_data();
    }, []);

    return (
        <div className={`relative`}>
            {showLoader && (
                <div className={`absolute p-8 w-full h-full z-[2px] bg-white bg-opacity-30`}>
                    <Loader />
                </div>
            )}
            <form onSubmit={handleSubmit(onSubmit)} className={`${showLoader ? `hidden` : `block`}`}>
                <div className='pt-4 min-h-[calc(100vh-158px)]'>
                    <div className='bg-green-50 py-2 px-3'>
                        <h6 className='text-[0.813rem] font-semibold'>Date and Time</h6>
                        <p className='text-[0.813rem] font-normal mt-2'>{moment(spDate, `YYYY-MM-DD HH:mm:ss`).format(`MM/DD/YY hh:mm A`)}</p>
                    </div>

                    <div>
                        <div className={`mt-4`}>

                            <Controller
                                name={`facilityID`}
                                control={control}
                                rules={{ required: "Facility is required" }}
                                render={({ field: { value, onChange } }) => (
                                    <SelectBox
                                        label="Select Facility"
                                        value={value}
                                        onChange={onChange}
                                        required
                                        placeholder="Choose Facility"
                                        options={facilityoption}
                                        className="mb-0"
                                        error={errors.facilityID?.message as any}
                                    />
                                )}
                            />

                            {/*816px*/}
                            <div className={`border border-[#043E6133] rounded-[5px] w-full overflow-x-auto mt-6  parts-table`}>
                                <div className={`flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]`}>
                                    <div className={`w-36 min-w-36 max-w-36 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] flex items-center`}>Part Code</div>                          {/* 144px */}
                                    <div className={`w-[304px] min-w-[304px] max-w-[304px] font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] flex items-center`}>Part Name</div>           {/* 270px */}
                                    <div className={`w-28 min-w-28 max-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center justify-end`}>Required Qty</div>      {/* 112px */}
                                    <div className={`w-28 min-w-28 max-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center justify-end`}>Available Qty</div>     {/* 112px */}
                                    <div className={`w-36 min-w-36 max-w-36 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] pl-2.5 pr-4 py-2 h-[50px] grow flex items-center justify-end`}>Picked Qty</div>   {/* 144px */}
                                </div>
                                <div ref={divRef}>
                                    {showPartsLoader && (
                                        <div className={`flex items-center justify-center h-24 text-gray-500`}>
                                            <Loader />
                                        </div>
                                    )}
                                    {!showPartsLoader && partsItems.length === 0 && (
                                        <div className={`flex items-center justify-center h-24 text-gray-500`}>
                                            No parts added yet.
                                        </div>
                                    )}
                                    {partsItems.map((part, index) => (
                                        <div className={`flex items-center flex-nowrap`} key={`part-item-${index}`}>
                                            <div className={`w-36 min-w-36 font-normal text-[#42484B] text-[14px] px-2.5 min-h-12 max-h-12 flex items-center bg-[#F9F9F9] cursor-not-allowed ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>{part.partCode || `--`}</div>
                                            <div className={`w-[304px] min-w-[304px] font-normal text-[#42484B] text-[14px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-not-allowed ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                                <div className={`preview-value line-clamp-1`} title={part.PartName}>{part.PartName || `--`}</div>
                                            </div>
                                            <div className={`w-28 min-w-28 font-normal text-[#42484B] text-[14px] px-2.5 min-h-12 max-h-12 flex items-center justify-end bg-[#F9F9F9] cursor-not-allowed ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>{part.requiredQty || `--`} {part.unitCode}</div>
                                            <div className={`w-28 min-w-28 font-normal text-[#42484B] text-[14px] px-2.5 min-h-12 max-h-12 flex items-center justify-end bg-[#F9F9F9] cursor-not-allowed ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                                <Suspense fallback={<span>--</span>}>
                                                    <PartsAvailableCountLazy PartID={part.partID} index={index} facilityID={facilityIDWatcher?.value || null} onCaptureData={(data: any) => {
                                                        console.log('Available Count Data =>', data);
                                                        const updatedParts = [...partsItems];
                                                        if (data && data.index >= 0 && data.index < updatedParts.length) {
                                                            updatedParts[data.index].availableQty = data.qty;
                                                            setPartsItems(updatedParts);
                                                        }
                                                    }} />
                                                </Suspense>&nbsp;
                                                {part.unitCode}
                                            </div>
                                            <div className={`w-36 min-w-36 font-normal text-[#42484B] bg-white text-[14px] px-2.5 py-3 min-h-12 max-h-12 flex justify-end flex-col cursor-pointer ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`} id={`part-item-qty-${index}`} onClick={(e: any) => {
                                                /*
                                                handleOnClickCellEdit(`part-item-qty-${index}`, e);
                                                e.stopPropagation();
                                                e.preventDefault();
                                                */
                                            }}>
                                                <div className={`text-right`}>
                                                    <div className={`preview-value hidden`} title={(+part.receivingQty > 0) ? (`Quantity is: ` + part.receivingQty) : `Click here to add data`}>{part.receivingQty || 0} {part.unitCode}</div>
                                                    <div className={`edit-value`}>
                                                        <div className={`flex items-center justify-end gap-1`}>
                                                            <input
                                                                type="tel"
                                                                className={`w-full border border-gray-300 rounded px-2 py-1 outline-none text-right`}
                                                                value={part.pickQty || ``}
                                                                placeholder={`Enter Qty`}
                                                                onChange={(e) => {
                                                                    const newQty = +e.target.value;
                                                                    var pickQty = isNaN(newQty) ? 0 : newQty;
                                                                    if (pickQty > part.availableQty) {
                                                                        pickQty = part.availableQty;
                                                                    }
                                                                    const updatedParts = [...partsItems];
                                                                    updatedParts[index].pickQty = pickQty;
                                                                    setPartsItems(updatedParts);
                                                                    /*
                                                                    if (pickQty > part.availableQty) {
                                                                        if (!e.target.classList.contains(`border-red-500`)) e.target.classList.add(`border-red-500`);
                                                                    } else {
                                                                        if (e.target.classList.contains(`border-red-500`)) e.target.classList.remove(`border-red-500`);
                                                                    }
                                                                    */
                                                                }}
                                                            />
                                                            <div className={`min-w-6 max-w-6 text-left`}>{part.unitCode}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <div className={`sticky bottom-0 bg-white z-[1px]`}>
                    <hr className={`border-gray-900 my-4 sticky z-[1px] bottom-6`} />
                    <div className={`flex justify-end gap-2`}>
                        <Button type={`submit`} childstyle={{ paddingLeft: `15px`, paddingRight: `15px` }}>Save</Button>
                        <Button theme='secondary' onClick={() => {
                            onCancel();
                        }}>Cancel</Button>
                    </div>
                </div>
            </form>
        </div>
    );
};
export default CreateStockpickingSingleWO;